import axios from "axios";
import { getToken } from "@core/utils/enum/token";

// CoinGecko USD + AUD prices for the DWallet tokens, cached 10 minutes.
// Returns { BTC: { usd, aud }, ... } — tokens missing from the map have no
// CoinGecko price; callers fall back to the DWallet rate / hide the A$ part.
const TTL_MS = 10 * 60 * 1000;

let cache = { prices: {}, fetchedAt: 0 };

export async function getTokenPrices(symbols = []) {
  const wanted = symbols
    .map((s) => String(s).toUpperCase())
    .filter((s) => getToken(s));
  if (!wanted.length) return {};

  const fresh = Date.now() - cache.fetchedAt < TTL_MS;
  if (fresh && wanted.every((s) => cache.prices[s])) return cache.prices;

  try {
    const ids = wanted.map((s) => getToken(s).coingeckoId).join(",");
    const { data } = await axios.get(
      `https://api.coingecko.com/api/v3/simple/price?ids=${ids}&vs_currencies=usd,aud&precision=full`,
      { timeout: 8000 },
    );
    const prices = {};
    wanted.forEach((sym) => {
      const p = data?.[getToken(sym).coingeckoId];
      if (Number(p?.usd) > 0 && Number(p?.aud) > 0) {
        prices[sym] = { usd: Number(p.usd), aud: Number(p.aud) };
      }
    });
    cache = { prices, fetchedAt: Date.now() };
    return prices;
  } catch (e) {
    return cache.prices; // last known prices on failure (A$ hidden when empty)
  }
}
